export const DEFAULT_GRAPH_NAME = 'How You Met Me';

export function getGraphNameParam(params = {}) {
  const name = params.graphName || DEFAULT_GRAPH_NAME;
  try {
    return decodeURIComponent(name);
  } catch (error) {
    return name;
  }
}

export function getReadGraphPath(name = DEFAULT_GRAPH_NAME) {
  return `/map/${encodeURIComponent(name)}`;
}

export function getEditGraphPath(name = DEFAULT_GRAPH_NAME) {
  return name === DEFAULT_GRAPH_NAME ? '/edit' : `/edit/${encodeURIComponent(name)}`;
}
